import { gql } from '@apollo/client';

export const UPDATE_SIMPLE_PROCESS = gql`
    mutation UpdateSimpleProcess($id: Guid!, $input: UpdateSimpleProcessPatch!) {
        facility {
            process {
                updateSimpleProcess(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
